import { useTranslation } from 'react-i18next';

import { Switch } from '@/components/ui/switch';

export const MemberQuickViewPreviewToggle = ({
  checked,
  onCheckedChange,
  id = 'member-quick-view-extended',
}: {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  id?: string;
}) => {
  const { t } = useTranslation('people');

  return (
    <div className="flex items-center gap-2">
      <label htmlFor={id} className="cursor-pointer text-caption text-fg-secondary">
        {t('members.preview.extended')}
      </label>
      <Switch id={id} checked={checked} onCheckedChange={onCheckedChange} aria-label={t('members.preview.extended')} />
    </div>
  );
};
